import { SlideKind } from '@duke-hq/svc-api-db';
import { TextIcon, FileQuestionIcon, FileSignature, Group, Upload } from 'lucide-react';

export function getSlideIcon(type: SlideKind) {
  switch (type) {
    case SlideKind.CONTENT:
      return <TextIcon />;
    case SlideKind.OPEN_QUESTION:
      return <FileQuestionIcon />;
    case SlideKind.FORM:
      return <FileSignature />;
    case SlideKind.QUESTION_GROUP:
      return <Group />;
    case SlideKind.FILE_UPLOAD_PROMPT:
      return <Upload />;
  }
}
